import script from "./invoicecard.vue?vue&type=script&setup=true&lang=js"
export * from "./invoicecard.vue?vue&type=script&setup=true&lang=js"

import "./invoicecard.vue?vue&type=style&index=0&id=5ab73ffa&lang=css"

const __exports__ = script;

export default __exports__